import { render, staticRenderFns } from "./TestWork.vue?vue&type=template&id=0042ee28&scoped=true&"
import script from "./TestWork.vue?vue&type=script&lang=js&"
export * from "./TestWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0042ee28",
  null
  
)

export default component.exports